const TYPE_MASTER = "master";
const TYPE_CARD = "card";
const SEPARATOR = "_";

export { TYPE_MASTER, TYPE_CARD, SEPARATOR };
